import React from 'react';
import { useDrop } from 'react-dnd';

import DragDropItem from './drag-drop-item';

const DropZone = ({ index, items, moveListItem, children }) => {
  const [{ isOver }, drop] = useDrop({
    accept: 'draggable-item',
    drop: item => moveListItem(index, item),
    collect: monitor => ({
      isOver: !!monitor.isOver(),
    }),
  });

  return (
    <div ref={drop} className={`drop-zone ${isOver ? 'is-over' : ''}`}>
      {items &&
        items.map((item, idx) => (
          <DragDropItem key={idx} name={item} listIdx={index} index={idx} />
        ))}
      {children}
    </div>
  );
};

export default DropZone;
